import AScene from "../../library/ExtendedObjects/AScene.js";

export default class LikeEffect
{
    /**
     * @param {AScene} scene 
     */
    constructor(scene)
    {
        this.scene = scene;

        this.spawnDelay_Max = .4;
        this.spawnDelay_Min = .3;
        this.duration = 3;
        this.heartSpeed_Min = 3.7;
        this.heartSpeed_Max = 4;
        this.heartWaveFrequency_Min = .001;
        this.heartWaveFrequency_Max = .002;
        this.heartWaveLength_Min = 1;
        this.heartWaveLength_Max = 3;
        this.heartScale_Min = .4;
        this.heartScale_Max = .6;

        this.hearts = [];
        this.curSpawnTime = 0;
        this.spawnTimer = 0;

        this.isSpawning = false;
        this.isPlaying = false;
        this.timer = 0;
    }

    playEffect()
    {
        this.isPlaying = true;
        this.isSpawning = true;
        this.spawnTimer = 0;
    }

    spawnHeart()
    {
        this.scene.playSound("heart", .7);

        let heart = this.scene.addImage(this.getValueBetween(200, this.scene.size.width - 200) ,this.scene.size.height - 200, "Heart");
        heart.delta = Math.random() * 100;
        heart.speed = this.getValueBetween(this.heartSpeed_Min, this.heartWaveLength_Max);
        heart.amplitude = this.getValueBetween(this.heartWaveLength_Min, this.heartWaveLength_Max);
        heart.waveFrequency = this.getValueBetween(this.heartWaveFrequency_Min, this.heartWaveFrequency_Max);
        this.hearts.push(heart);

        heart.alpha = 0; 
        heart.setScale(0);
        let scale = this.getValueBetween(this.heartScale_Min, this.heartScale_Max);

        this.scene.addTween(heart, 5000, {alpha: 1, scaleX: scale, scaleY: scale}, Phaser.Math.Easing.Back.Out);
    }

    update(delta)
    {
        if(!this.isPlaying) return;

        this.timer += delta/1000;
        this.spawnTimer += delta/1000;

        if(this.spawnTimer >= this.curSpawnTime && this.isSpawning)
        {
            
            this.spawnTimer = 0;
            this.curSpawnTime = this.getValueBetween(this.spawnDelay_Min, this.spawnDelay_Max);
            
            this.spawnHeart();
        }
        
        if(this.timer >= this.duration)
        {
            this.isSpawning = false;
        }

        for(let i = 0; i < this.hearts.length; i++)
        {
            let heart = this.hearts[i];

            heart.y -= heart.speed;
            heart.x += Math.sin(heart.delta) * heart.amplitude;
            heart.delta += delta * heart.waveFrequency;

            if(heart.y < 200 && !heart.markForDeletion) 
            {
                heart.markForDeletion = true;
                this.scene.addTween(heart, 1000, { scaleX: 0, scaleY: 0, alpha: 0 }, Phaser.Math.Easing.Sine.Out, () => {
                    let toDestroy = this.hearts.splice(this.hearts.indexOf(heart), 1)[0];
                    toDestroy.destroy();

                    if (this.hearts.length <= 0) {
                        this.timer = 0;
                        this.spawnTimer = 0;
                        this.isPlaying = false;
                    }
                });
            }
        }
    }

    getValueBetween(min, max)
    {
        return ((max - min) * Math.random()) + min;
    }
}